/**
 * Get currency symbol from currency code
 *
 * @param moneda - Currency code (PEN, USD, EUR)
 * @returns Currency symbol
 */
export function getCurrencySymbol(moneda: string): string {
	switch (moneda) {
		case "PEN":
			return "S/";
		case "USD":
			return "$";
		case "EUR":
			return "€";
		default:
			return moneda;
	}
}

/**
 * Format a number as currency with symbol
 * @param amount - The numeric amount to format
 * @param currency - Currency code (PEN, USD, EUR)
 * @param options - Optional Intl.NumberFormatOptions for customization
 * @returns Formatted currency string (e.g., "S/ 1,234.56")
 */
export function formatCurrency(
	amount: number,
	currency: string,
	options?: Intl.NumberFormatOptions,
): string {
	const symbol = getCurrencySymbol(currency);
	const formatted = Number(amount).toLocaleString("en-US", {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
		...options,
	});
	return `${symbol} ${formatted}`;
}

/**
 * Normalizes a value to its monthly equivalent based on periodicity
 *
 * @param value - The numeric value
 * @param period - The period (anual, mensual, semestral, etc)
 * @returns Monthly equivalent
 */
export function normalizeToMonthly(value: number, period: string): number {
	switch (period.toLowerCase()) {
		case "anual":
			return value / 12;
		case "semestral":
			return value / 6;
		case "trimestral":
			return value / 3;
		case "bimestral":
			return value / 2;
		case "mensual":
			return value;
		case "diaria":
			return value * 30; // Approximation
		case "unica":
			return value; // Should probably be handled separately, but for cashflow usually ignored or fully counted
		default:
			return value;
	}
}
